export const buildReferralLink = (referralCode: string) =>
  `https://app.vibx.com.br/auth/register?referrerCode=${referralCode}`;
